import { DoughnutChart } from '@commenda/kakashi';
import { themeColors } from './common';

const EsopPoolDonutChart = ({ esopPool }: { esopPool: number }) => {
  return (
    <div className="flex items-center justify-center relative h-40 w-40">
      <DoughnutChart
        values={[esopPool, 100 - esopPool]}
        colors={themeColors}
        labels={['ESOP Pool', 'Director Shares']}
      />
    </div>
  );
};

export default EsopPoolDonutChart;
